// globals: jQuery, Ajax, reportAjaxError, TakePayment

/**
 * @param initConfig
 */
export default class CashFlowIframeAbstract {
  constructor(defaultConfig) {
    this.config = defaultConfig ? { ...defaultConfig } : {};
  }

  init(initConfig) {
    if (initConfig) {
      this.config = { ...this.config, ...initConfig };
    }

    const defaultFirstName = 'Primary';
    const defaultLastName = 'User';
    const firstName = document.querySelector('#first_name')?.value ?? defaultFirstName;
    const lastName = document.querySelector('#last_name')?.value ?? defaultLastName;
    const cashFlowIframeUrl = document.querySelector('#gatewayIframeUrl')?.value;
    const cashFlowCcAccountId = document.querySelector('#gatewayCcAccountId')?.value;
    const cashFlowCcPublicKey = document.querySelector('#gatewayCcPublicKey')?.value;
    const cashFlowAchAccountId = document.querySelector('#gatewayAchAccountId')?.value;
    const cashFlowAchPublicKey = document.querySelector('#gatewayAchPublicKey')?.value;
    const memberId = document.querySelector('#member_id')?.value;
    const cssLayout = 'width: 100%;height: auto; margin-bottom:40px;';
    const userId = document.querySelector('#user_id')?.value;
    const defaultSystemId = Date.now();
    const memberUserID = userId ?? memberId;
    const uniqueId = memberUserID ?? defaultSystemId;
    const systemId = `${cashFlowCcAccountId}${uniqueId}`;
    const systemIdAch = `${cashFlowAchAccountId}${uniqueId}`;
    let iframeStyle = '';
    const errorMessage = '';
    let html = errorMessage;
    let cvvVal;
    let ccName;
    let postalCode;

    if (userId && this.config.iframeLocation !== 'pos') {
      cvvVal = 'false';
      ccName = 'false';
      postalCode = 'false';
      if (typeof memberId !== 'undefined' && memberId === userId) {
        cvvVal = 'true';
      }
    } else if (document.querySelector('#agreements')?.value === 'v1') {
      cvvVal = 'false';
      ccName = 'false';
      postalCode = 'false';
    } else {
      cvvVal = 'false';
      ccName = 'true';
      postalCode = 'true';
    }
    if (this.config.iframeLocation === 'profile' && document.querySelector('#paymenttype')?.value === undefined) {
      cvvVal = 'true';
    }
    if (this.config.iframeLocation === 'profile') {
      if (document.querySelector('#paymenttype')?.value === 'bank') {
        html += `<tokenize-payment-method public-key="${cashFlowAchPublicKey}" style = "${cssLayout}" service-uri="${cashFlowIframeUrl}" last-name="${lastName}" first-name="${firstName}" system-id="${systemIdAch}" wallet-id="" phone="" country="" type="2" hasEmailField = "false" has-submit-button = "false" is-save-for-future-use = "true"></tokenize-payment-method>`;
        html += '<button name="useExternalButton" id="useExternalButton" type="button" class="emv-terminal-btn-cashflow btn btn-primary">Continue</button>';
        jQuery(`#${this.config.frameContainer}`).html(html);

        // Works when user clicks on external button
        jQuery('#useExternalButton').click(() => {
          const addBankElement = document.querySelector('tokenize-payment-method');
          const iframe = addBankElement.shadowRoot.children[0].getElementsByTagName('iframe')[0];
          iframe.contentWindow.postMessage({ eventName: 'cashFlowFormSubmit' }, '*');
        });

        const addBankElement = document.querySelector('tokenize-payment-method');
        addBankElement.addEventListener('paymentAddedSuccess', (event) => {
          const data = event.detail;
          jQuery('.cashFlowIframeError').html('');
          const $form = this.config.cashFlowParamsToFormSelector ? jQuery(this.config.cashFlowParamsToFormSelector) : jQuery(form);
          const cardnumber = data.bankIdentifier;
          const firstBnk = cardnumber.substring(0, 1); // used for card connect
          const lastTwo = cardnumber.substring(cardnumber.length - 2); // used for card connect
          const masked = cardnumber.substring(1, cardnumber.length - 2).replace(/\d/g, '*'); // used for card connect
          const maskedVal = firstBnk + masked + lastTwo; // used for card connect
          const lastFour = cardnumber.substring(cardnumber.length - 4);
          $form.find('[name=checking_account_number]').val(`******${data.lastFourDigits}`).prop('readonly', true);
          $form.find('[name=account_number]').val(`******${data.lastFourDigits}`).prop('readonly', true);
          $form.find('[name=account_number2]').val(`******${data.lastFourDigits}`);
          $form.find('[name=routing_number]').val(`******${lastFour}`).prop('readonly', true);
          jQuery('#payment_processor_unique_id').val(data.token);
          const myselect = (data.accountType === 5 || data.accountType === 'Checking account') ? '1' : '2';
          jQuery('#bnkifm').parents('.ui-dialog').find('.ca-titlebar-close').click();
          jQuery(`#bank_account_type option[value='${myselect}']`).prop('selected', 'selected');
          this.setCashFlowParamsToFormBank($form, data, () => {
            this.onSuccess($form, data);
          });
        });
      } else {
        // To iframe use for Member agreement and Staff portal
        html += `<tokenize-payment-method public-key="${cashFlowCcPublicKey}" style = "${cssLayout}" service-uri="${cashFlowIframeUrl}" last-name="${lastName}" first-name="${firstName}" system-id="${systemId}" wallet-id="" phone="" country="" type="1" show-card-preview="false" has-cvv-field="${cvvVal}" has-name-field="${ccName}"  has-postal-code-field = "${postalCode}" has-submit-button = "false" is-save-for-future-use = "true"></tokenize-payment-method>`;
        html += '<input type="hidden" value="" name="mytoken" id="mytoken" />';
        html += '<input type="hidden" value="" name="myexpiry" id="myexpiry" />';
        html += '<button name="useExternalButton" id="useExternalButton" type="button" class="emv-terminal-btn-cashflow btn btn-primary">Continue</button>';
        jQuery(`#${this.config.frameContainer}`).html(html);

        // Works when user clicks on external button
        jQuery('#useExternalButton').click(() => {
          const addCardElement = document.querySelector('tokenize-payment-method');
          const iframe = addCardElement.shadowRoot.children[0].getElementsByTagName('iframe')[0];
          iframe.contentWindow.postMessage({ eventName: 'cashFlowFormSubmit' }, '*');
        });

        const addCardElement = document.querySelector('tokenize-payment-method');
        addCardElement.addEventListener('paymentAddedSuccess', (event) => {
          const data = event.detail;
          const mytoken = document.getElementById('mytoken');
          const myexpiry = document.getElementById('myexpiry');
          if (typeof (data.token) !== 'undefined' && typeof (data.expirationDate) !== 'undefined') {
            mytoken.value = data.token;
            myexpiry.value = data.expirationDate;
            jQuery('#cc_type').val(data.brand);
          }
          jQuery('.cashFlowIframeError').html('');

          const $form = this.config.cashFlowParamsToFormSelector ? jQuery(this.config.cashFlowParamsToFormSelector) : jQuery(form);
          this.setCashFlowParamsToForm($form, data, () => {
            this.onSuccess($form, data);
          });
        });
      }
    } else if (this.config.iframeLocation === 'pos') {
      html += `<tokenize-payment-method public-key="${cashFlowCcPublicKey}" styles="" service-uri="${cashFlowIframeUrl}" last-name="${lastName}" first-name="${firstName}" system-id="${systemId}" wallet-id="" phone-number = "false" country="" type="1" show-card-preview="false" has-cvv-field="true" name-required="false" has-submit-button = "true" is-save-for-future-use = "true"></tokenize-payment-method>`;
      html += '<input type="hidden" value="" name="mytoken" id="mytoken" />';
      html += '<input type="hidden" value="" name="myexpiry" id="myexpiry" />';
      html += '<input type="hidden" value="" name="ccType" id="ccType" />';
      jQuery(`#${this.config.frameContainer}`).html(html);
      const addCardElement = document.querySelector('tokenize-payment-method');
      // event listener
      addCardElement.addEventListener('paymentAddedSuccess', (event) => {
        jQuery('.ca-loading-splash-container').css('display', 'block');
        jQuery('.overlay_layer').css('display', 'block');
        const data = event.detail;
        const mytoken = document.getElementById('mytoken');
        const myexpiry = document.getElementById('myexpiry');
        const ccType = document.getElementById('ccType');
        if (typeof (data.token) !== 'undefined' && typeof (data.expirationDate) !== 'undefined') {
          mytoken.value = data.token;
          myexpiry.value = data.expirationDate;
          ccType.value = data.brand;
        }
        const $form = this.config.cashFlowParamsToFormSelector ? jQuery(this.config.cashFlowParamsToFormSelector) : jQuery(form);
        this.setCashFlowParamsToForm($form, data, () => {
          this.onSuccess($form, data);
        });
        const url = '/payment/take-payment?&ajax=true';
        new Ajax.Request(
          url,
          {
            method: 'post',
            parameters: jQuery('#takePaymentForm, #pos_form').serialize(),
            onComplete(response) {
              jQuery('#take_payment').html(response.responseText);
              jQuery('.ca-loading-splash-container').css('display', 'none');
              jQuery('.overlay_layer').css('display', 'none');
            },
            onFailure() {
              alert('fail');
              jQuery('.ca-loading-splash-container').css('display', 'none');
              jQuery('.overlay_layer').css('display', 'none');
            },
          },
        );
      });
    }

    if (typeof (this.config.iframeStyle) !== 'undefined') {
      iframeStyle = this.config.iframeStyle;
    }

    if (this.config.isEmvTerminal) {
      const $useEmvTerminalBtn = jQuery(this.config.formSelector)
        .find('#useEmvTerminalBtn');
      $useEmvTerminalBtn.removeClass('hidden');
      $useEmvTerminalBtn.on('click', function () {
        this.openEmvTerminal();
      });
    }
  }

  onEmvSuccess() {
    // Interface needed after on success of emv payment
  }

  openEmvTerminal() {
    TakePayment.callTerminal(
      {},
      (data) => {
        const $dialogContent = jQuery('<div>'
                    + '<p class="pos-terminal-text">Please process payment through the EMV terminal.</p>'
                    + '</div>');

        const url = '/payment/emv-terminal-create-token';

        new Ajax.Request(
          url,
          {
            method: 'post',
            parameters: data,
            onComplete(request) {
              $dialogContent.caDialog('close');
              const { responseJSON } = request;
              if (request.status === 0) {
                return false;
              }
              if (responseJSON.status === 1) {
                this.onEmvSuccess(responseJSON.token);
              }
            },
            onFailure: reportAjaxError,
          },
        );
        $dialogContent.caDialog({
          title: 'Transaction In Progress...',
          resizable: false,
          width: 600,
          showCloseButton: false,
          modal: true,
        });
      },
    );
  }

  onSuccess() {
    // Interface needed after on success of card payment
  }

  /**
     * @param $form
     * @param data
     * @param callback
     */
  setCashFlowParamsToForm($form, data, callback) {
    const array = data.expirationDate.split('/');
    let expiration_month = array[0];
    const date = new Date();
    const year = date.getFullYear().toString().slice(0, 2);
    const expiration_year = `${year}${array[1]}`;

    if (expiration_month.length === 1) {
      expiration_month = `0${expiration_month}`;
    }

    const expiration_date = `${expiration_year}-${expiration_month}-01`;

    const ccNumberEscape = `${Array(13).join('*')}${data.lastFourDigits}`;
    const activeGatewayAll = jQuery('#activeGatewayAll').val();
    const houseCharge = jQuery('#house_charge').val();
    $form.find('[name=cc_date]').val(expiration_date);
    $form.find('[name=cc_number],[name="ccInfo[ccNumber]"],[name=card_number]').val(ccNumberEscape);
    $form.find('[name=cc_name],[name="ccInfo[ccName]"],[name=ccName]').val(data.name);
    $form.find('#cc_date-month').val(expiration_month);
    $form.find('#cc_date-year').val(expiration_year);
    jQuery('#ccInfo-ccNumber').val(ccNumberEscape);
    jQuery('#cc_date').val(expiration_year + expiration_month);
    jQuery('#myexpiry').val(expiration_year + expiration_month);
    jQuery('#ccInfo-expDate').val(expiration_year + expiration_month);

    jQuery('#cc_merchant_unique_id').val(data.token);
    if (activeGatewayAll === 'cashflow' && houseCharge === 'credit card') {
      jQuery('.cash_cc_name').prop('readonly', true);
      jQuery('.cash_cc_date').css('pointer-events', 'none');
    }
    $form.find('[name=cc_merchant_unique_id]').val(data.token);
    data.expiration_month = expiration_month;
    data.expiration_year = expiration_year;
    data.cc_merchant_unique_id = data.token;
    data.cc_type = data.brand;
    data.cc_number = ccNumberEscape;
    callback();
  }

  setCashFlowParamsToFormBank($form, data, callback) {
    const accountNumberEscape = data.lastFourDigits;
    let accountType;
    // 5 returns for Checkings Ach ACCOUNT From CashFlow
    if (data.accountType === 5) {
      accountType = 'Checkings';
    } else {
      accountType = 'Savings';
    }
    data.account_type = accountType;
    data.routing_number = data.bankIdentifier;
    data.ba_merchant_unique_id = data.token;
    data.account_number = accountNumberEscape;
    callback();
  }
}
